/**
 * @description Shared merchant account status badge helpers (admin portal)
 *
 * Key features:
 * - Three-state: active | inactive | unlinked (auth can-sign-in contract)
 * - Prefers accountStatus; falls back to isActive boolean|null
 *
 * @dependencies
 * - None
 *
 * @notes
 * - Status ⊥ Hosting Paid — never derive from hostingTier
 * - unlinked ≠ inactive: join miss vs banned (agent-actionable)
 */

/**
 * @param {{ accountStatus?: string, isActive?: boolean|null }} merchant
 * @returns {'active'|'inactive'|'unlinked'}
 */
export function resolveMerchantAccountStatus(merchant) {
  if (merchant?.accountStatus === 'active' || merchant?.accountStatus === 'inactive' || merchant?.accountStatus === 'unlinked') {
    return merchant.accountStatus;
  }
  if (merchant?.isActive === true) return 'active';
  if (merchant?.isActive === false) return 'inactive';
  return 'unlinked';
}

/**
 * @param {'active'|'inactive'|'unlinked'} status
 * @returns {{ label: string, className: string }}
 */
export function merchantAccountStatusBadge(status) {
  switch (status) {
    case 'active':
      return { label: 'Active', className: 'bg-green-50 text-green-700' };
    case 'inactive':
      return { label: 'Inactive', className: 'bg-gray-100 text-gray-500' };
    case 'unlinked':
    default:
      return { label: 'Unlinked', className: 'bg-amber-50 text-amber-700' };
  }
}
